import React from 'react';
import {FormattedMessage} from 'react-intl';

import {Banner} from '@stubhub/bamboo';

import './index.scss';

const LocalDeliveryNote = () => {
  return (
    <Banner
      status="warning"
      id="localDeliveryNote"
      title={<FormattedMessage id="LocalDeliveryNote.title" defaultMessage="Local delivery address required" />}
      className="RoyalBuildYourOrder__body_section localDeliveryNote-container"
    >
      <FormattedMessage
        id="LocalDeliveryNote.message"
        defaultMessage="These tickets need to be sent to an address in the same country as the event. If you won't be able to provide a local delivery address, please choose different tickets."
      />
    </Banner>
  );
};

export default LocalDeliveryNote;
